export type UserLabelShape = {
  id?: string | null
  name?: string | null
  display_name?: string | null
  full_name?: string | null
  first_name?: string | null
  last_name?: string | null
  email?: string | null
}

const UUID_RE =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i

function isMeaningful(value: unknown): value is string {
  return typeof value === 'string' && value.trim().length > 0
}

function isUuidLike(value: string): boolean {
  return UUID_RE.test(value.trim())
}

export function getUserDisplayName(user: UserLabelShape | null | undefined): string {
  if (!user) return ''

  const first = isMeaningful(user.first_name) ? user.first_name.trim() : ''
  const last = isMeaningful(user.last_name) ? user.last_name.trim() : ''
  const firstLast = `${first} ${last}`.trim()
  if (isMeaningful(firstLast)) return firstLast

  const preferred = [user.display_name, user.full_name]
    .filter(isMeaningful)
    .map((value) => value.trim())
    .find((value) => !isUuidLike(value))
  if (preferred) return preferred

  if (isMeaningful(user.name)) {
    const normalizedName = user.name.trim()
    if (!isUuidLike(normalizedName)) return normalizedName
  }

  if (isMeaningful(user.email)) return user.email.trim()
  if (isMeaningful(user.id)) return user.id.trim()
  return ''
}

export function getUserOptionLabel(user: UserLabelShape | null | undefined): string {
  const base = getUserDisplayName(user)
  if (!base) return 'Unknown user'

  const email = isMeaningful(user?.email) ? user!.email!.trim() : ''
  if (!email || base.toLowerCase() === email.toLowerCase()) return base
  return `${base} (${email})`
}
